module.exports = __webpack_public_path__ + "img/50fba4141940cac8d023a56507bf0aa.f5204f8f.jpg";